import { render, staticRenderFns } from "./address.vue?vue&type=template&id=e1152358&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=e1152358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1152358",
  null
  
)

export default component.exports